import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentModel, PaymentCheckModel, SubscriberModel } from '../models/superbit-api-models';
import { SubscribersModel } from '../models/SubscribersModel';
import '../assets/css/_simple-popup.css'
//import './_VehicleDetails.css'
import '../vehicles/_VehicleDetails.css'
import { GovData1, GovData2, ManulApiModel } from '../models/ManulApiModel'
import { GetBanks } from '../models/CacheModel'
import exampleIcon from '../assets/images/license2.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { SimulatorModel } from '../models/SimulatorModel';

import { DynamicSelect } from '../components/_DynamicSelect';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import { Autocomplete } from '../components/_Autocomplete';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import VehicleDetails from "../vehicles/_VehicleDetails";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { GeneralDataModel } from '../models/GeneralDataModel';
type Props = {
    paymentData: any;
    PaymentId: string | undefined,
    RiderId: string | undefined,
    SaveEventHandle: string;
    ClosePopup: Function;
    Reload: Function;
    setPopupShow: React.Dispatch<React.SetStateAction<boolean>>
    setMessege: React.Dispatch<React.SetStateAction<string>>
    isAdmin: () => boolean;
    setSaveLoading: (value: boolean) => void;
};

class PaymentCheckWithErrors {

    paymentCheck: PaymentCheckModel;
    errors: {
        checkNumberErrorMsg?: string;
        dueDateErrorMsg?: string;
        amountErrorMsg?: string;
        bankNumberErrorMsg?: string;
        branchNumberErrorMsg?: string;
        accountNumberErrorMsg?: string;
        // Add error fields for other properties
    };

    constructor(paymentCheck: PaymentCheckModel) {
        this.paymentCheck = paymentCheck;
        this.errors = {};
    }
}

const currentDate = moment();


const Payment = (props: Props) => {
    const [id, setId] = useState<string | undefined>(undefined);
    const [riderId, setRiderId] = useState<string | undefined>(undefined);
    const [title, setTitle] = useState<string | undefined>(undefined);
    const [comment, setComment] = useState<string | undefined>(undefined);
    const [amount, setAmount] = useState<number | undefined>(undefined);
    const [oldAmount, setOldAmount] = useState<number | undefined>(undefined);
    const [paymentMethodType, setPaymentMethodType] = useState<number | undefined>(-1);
    const [paymentsNumber, setPaymentsNumber] = useState<number | undefined>(undefined);
    const [maxPayments, setMaxPayments] = useState<number | undefined>(undefined);
    const [paymentStatus, setPaymentStatus] = useState<number | undefined>(undefined);
    const [bankNumber, setBankNumber] = useState<number | undefined>(undefined);
    const [branchNumber, setBranchNumber] = useState<number | undefined>(undefined);
    const [accountNumber, setAccountNumber] = useState<number | undefined>(undefined);
    const [bankTransferDate, setBankTransferDate] = useState<Date | undefined>(new Date());
    const [cCChargeCreditId, setCCChargeCreditId] = useState<string | undefined>(undefined);

    const [paymentChecks, setPaymentChecks] = useState<PaymentCheckWithErrors[]>([]);
    const [paymentChecksErrMsg, setPaymentChecksErrMsg] = useState<string | undefined>(undefined);
    const [iCerditUrl, setICerditUrl] = useState<string | undefined>(undefined);
    const [iframeHeight, setIframeHeight] = useState('0px');
    const [PaymentMethodTypes, setPaymentMethodTypes] = useState<IDNameDescriptionDictionary>(new SubscribersModel().getPaymentMethodType());
    const [paymentStatuses, setPaymentStatuses] = useState<IDNameDescriptionDictionary>(new SubscribersModel().getPaymentStatuses());
    const [Banks, setBanks] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [Branches, setBranches] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [ChecksBranches, setChecksBranches] = useState<IDNameDescriptionDictionary[]>([]);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [askedPay, setAskedPay] = useState<boolean>(false);
    const [newPayment, setNewPayment] = useState<boolean>(false);
    const [showAskedPayPopup, setShowAskedPayPopup] = useState<boolean>(false);
    const [continueWothoutPaying, setContinueWothoutPaying] = useState<boolean>(false);
    const [ccChargeCredit, setCcChargeCredit] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [bankTransferDateErrMsg, setBankTransferDateErrMsg] = useState<string | undefined>(undefined);
    const [bankNumberErrMsg, setBankNumberErrMsg] = useState<string | undefined>(undefined);
    const [branchNumberErrMsg, setBranchNumberErrMsg] = useState<string | undefined>(undefined);
    const [accountNumberErrMsg, setAccountNumberErrMsg] = useState<string | undefined>(undefined);
    const [paymentErr, setPaymentErr] = useState<string | undefined>(undefined);

    const minValidDate = new Date("0001-01-02"); // Date just after "01/01/0001"

      const paymentOptions = Array.from({ length: 12 }, (_, i) => i + 1);

    useEffect(() => {
        // Define the function to be called by the iframe
        const handleMessage = (event: MessageEvent) => {
            console.log('callParentFunction.... response', event.data);
            if (event.data === 'callParentFunction') {
                //click create payment
                setTimeout(() => {
                    console.log('callParentFunction.... ClosePopup', event.data);
                    props.ClosePopup();
                    props.setPopupShow(true);
                    props.setMessege("תשלום נקלט ואושר חשבונית קיימת בכרטיס הלקוח");

                    setTimeout(() => {
                        console.log('callParentFunction.... ClosePopup', event.data);
                        props.ClosePopup();
                        
                    }, 3000);
                }, 3000);

            }
        };

        // Add event listener for messages from iframe
        window.addEventListener('message', handleMessage);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        init();
    }, [props.PaymentId])

    useEffect(() => {
        setOldAmount(amount);
    }, [])




    useEffect(() => {
        if (continueWothoutPaying) {
            savePayment();

        } else {
            setAskedPay(false);
        }
    }, [showAskedPayPopup]);

    useEffect(() => {
        if (isLoaded) {
            savePayment();
        }
    }, [props.SaveEventHandle]);

    const closePopup = () => {
        props.ClosePopup();
        console.log('closePopup')
    }

    const init = async () => {
        // 
        setRiderId(props.RiderId);

        let paymentsStatusList = await new SubscribersModel().getPaymentMethodType()
        if(props.paymentData){
            if(props.paymentData.paymentStatus == 1 && props.paymentData.amount > 0 && props.paymentData.paymentMethodType==0){
                setPaymentMethodTypes(paymentsStatusList);
            } else{
                if(props.paymentData.paymentStatus == 1 && props.paymentData.amount > 0 && props.paymentData.paymentMethodType !=0){
                    setPaymentMethodTypes(
                        {"1": {id: 1, name: "Check", description: "המחאה"},
                        "3":{id: 3,name: "Other",description: "אחר"}});
                                        // setPaymentMethodTypes(paymentsStatusList);

                        setPaymentMethodType(3);
                }
                else
                {
                    setPaymentMethodTypes(paymentsStatusList);
                }
            }
        }


        setPaymentStatuses(await new SubscribersModel().getPaymentStatuses());

        if (props.PaymentId == "") {
            
            setTitle("");
            setAmount(0);
            setOldAmount(0);
            setNewPayment(true);
        }
        else {
            setNewPayment(false);
            var data = await new SubscribersModel().riderGetPaymentPage2(undefined, props.PaymentId);
            setRiderId(data.riderId);
            if(data.paymentStatus==1){
    
            }
            setId(data.id);
            setTitle(data.title);
            setComment(data.paymentDetails);
            setAmount(data.amount);
            setOldAmount(data.amount);
            setPaymentMethodType(data.paymentMethodType);
            setPaymentsNumber(data.paymentsNumber);
            setMaxPayments(12);
            setPaymentStatus(data.paymentStatus);
            setBankNumber(data.bankNumber);
            await bankNumberChanged("", data.bankNumber);
            setBranchNumber(data.branchNumber);
            await branchNumberChanged("", data.branchNumber);
            setAccountNumber(data.accountNumber);
            setAccountNumber(data.cc);
            await setPaymentChecks((data.paymentChecks.map((x: PaymentCheckModel) => new PaymentCheckWithErrors(x))));
            setCCChargeCreditId(data.CCChargeCreditId)

            if(props.paymentData){
                if(props.paymentData.paymentStatus == 1 && props.paymentData.amount > 0 && props.paymentData.paymentMethodType==0){
                    setPaymentMethodTypes(paymentsStatusList);
                } else{
                    if(data.amount < 0 && props.paymentData.paymentStatus == 1 && props.paymentData.amount > 0 && props.paymentData.paymentMethodType !=0){
                        setPaymentMethodTypes({"1": {id: 1, name: "Check", description: "המחאה"},
                        "3":{id: 3,name: "Other",description: "אחר"}});
                                            // setPaymentMethodTypes(paymentsStatusList);

                        setPaymentMethodType(3);
                    }
                    else
                    {
                        setPaymentMethodTypes(paymentsStatusList);
                    }
                }
            }

            if(props.paymentData.paymentStatus == 1 && props.paymentData.amount > 0 && props.paymentData.paymentMethodType !=0){
                setPaymentMethodType(3);
            }

            let dictionary = new IDNameDescriptionDictionary();

            const _key = "0";
            dictionary[_key] = new IDNameDescriptionItem();
            dictionary[_key].id = 0;
            dictionary[_key].name = "בחר";
            dictionary[_key].description = "בחר";

            if (data.ccChargeCredit) {
                data.ccChargeCredit.forEach((item: any, index: number) => {
                    const key = item.value ? item.value : `key${index}`;
                    dictionary[key] = new IDNameDescriptionItem();
                    dictionary[key].id = item.value;
                    dictionary[key].name = item.text;
                    dictionary[key].description = item.text;
                });

                setCcChargeCredit(dictionary);
            }

            const banksAllDetails = await new GeneralDataModel().getBankList();

            data.paymentChecks.forEach((item: PaymentCheckModel, index: number) => {

                const filteredBanks = banksAllDetails.filter((x: any) => x.Bank_Code == item.bankNumber);
                console.log("filteredBanks", filteredBanks);

                const _keysSet = new Set<number | string>();
                const branchDictionary = filteredBanks.reduce((acc: any, bank: any) => {
                    const key = bank.Branch_Code;
                    if (_keysSet.has(key)) {
                        console.log(`Duplicate key detected: ${key}`);
                    } else {
                        _keysSet.add(key);
                        acc[key] = {
                            id: bank.Branch_Code,
                            name: bank.Branch_Code + ' ' + bank.Branch_Name,
                            description: bank.Branch_Code + ' ' + bank.Branch_Name
                        };
                    }
                    return acc;
                }, {} as IDNameDescriptionDictionary);


                if (item.bankNumber) {





                    setChecksBranches(prevBranches => {
                        const newBranches = [...prevBranches];
                        newBranches[index] = branchDictionary;
                        //newBranches[index] = branchDictionary;
                        return newBranches;
                    });

                    bankNumberCheckChanged(index + "", item.bankNumber);
                }
            });

            setICerditUrl(data.iCerditUrl);
            setBankTransferDate(data.bankTransferDate > minValidDate ? data.bankTransferDate : "");


            var banksAllDetsils = await GetBanks();
            console.log("banksAll", banksAllDetsils);

            const keysSet = new Set<number | string>();
            const firstElement = {
                description: 'בחר',
                name: '',
                id: 0,
                package: null
            };

            const banksDictionary = banksAllDetsils.reduce((acc, bank: any) => {
                const key = bank.Bank_Code!;
                if (keysSet.has(key)) {
                    console.log(`Duplicate key detected: ${key}`);
                } else {
                    keysSet.add(key);
                    acc[key] = {
                        id: bank.Bank_Code!,
                        name: bank.Bank_Code + ' ' + bank.Bank_Name!,
                        description: bank.Bank_Code + ' ' + bank.Bank_Name!
                    };
                }
                return acc;
            }, {} as IDNameDescriptionDictionary);

            const result = {
                '0': firstElement, // Adding the first element with a key of '0'
                ...banksDictionary // Merging the rest of the dictionary
            };

            setBanks(result);
            setIsLoaded(true);
        }


    }



    const paymentMethodTypeChanged = async (name: string, value: any) => {
        setPaymentMethodType(value);

        console.log("paymentMethodTypeChanged name:" + name);
        console.log("paymentMethodTypeChanged value:" + value);
    }

    const paymentStatusChanged = async (name: string, value: any) => {
        setPaymentStatus(value);
    }

    const paymentNumberChanged = (_paymentNumber: number) => {
        

        setPaymentsNumber(_paymentNumber);
        if (paymentChecks && paymentChecks.length < _paymentNumber) {
            var checks = paymentChecks;
            var checksBranches = ChecksBranches;
            var newChcks = (_paymentNumber - paymentChecks.length);
            for (var i = 0; i < newChcks; i++) {
                checks.push(new PaymentCheckWithErrors(new PaymentCheckModel()));
                checksBranches.push(new IDNameDescriptionDictionary());
            }
            setPaymentChecks(checks);
            //setChecksBranches(checksBranches);
        }else{
            var checks = paymentChecks;
            var checksBranches = ChecksBranches;
            var newChcks = (paymentChecks.length - _paymentNumber);
            for (var i = 0; i < newChcks; i++) {
                checks.pop();
                checksBranches.pop();
            }
            setPaymentChecks(checks);
            //setChecksBranches(checksBranches);
        }
    }



    const bankNumberChanged = async (name: string, value: any) => {

        setBankNumber(value);
        var banksAllDetsils = await GetBanks();
        banksAllDetsils = banksAllDetsils.filter((x: any) => x.Bank_Code == value);

        const keysSet = new Set<number | string>();


        const firstElement = {
            description: 'בחר',
            name: '',
            id: 0,
            package: null
        };

        var branches = banksAllDetsils.reduce((acc, bank: any) => {
            const key = bank.Branch_Code!;
            if (keysSet.has(key)) {
                console.log(`Duplicate key detected: ${key}`);
            }
            else {
                keysSet.add(key);
                acc[key] = {
                    id: bank.Branch_Code!,
                    name: bank.Branch_Code + ' ' + bank.Branch_Name!,
                    description: bank.Branch_Code + ' ' + bank.Branch_Name!
                };
            }
            return acc;
        }, {} as IDNameDescriptionDictionary)
        const result = {
            '0': firstElement, // Adding the first element with a key of '0'
            ...branches // Merging the rest of the dictionary
        };

        setBranches(result);

    }

    const cCChargeCreditChanged = async (name: string, value: any) => {
        setCCChargeCreditId(value);
    }
    const bankNumberCheckChanged = async (name: string, value: any) => {
        const index = parseInt(name);

        // Update the payment checks state
        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];

            for (var i = index; i < newChecks.length; i++) {
                newChecks[i].paymentCheck.bankNumber = value;
            }
            return newChecks;
        });

        // Fetch and filter bank details
        const banksAllDetails = await GetBanks();
        const filteredBanks = banksAllDetails.filter((x: any) => x.Bank_Code == value);
        console.log("filteredBanks", filteredBanks);

        // Create a dictionary for the branches
        const keysSet = new Set<number | string>();
        const branchDictionary = filteredBanks.reduce((acc, bank: any) => {
            const key = bank.Branch_Code;
            if (keysSet.has(key)) {
                console.log(`Duplicate key detected: ${key}`);
            } else {
                keysSet.add(key);
                acc[key] = {
                    id: bank.Branch_Code,
                    name: bank.Branch_Code + ' ' + bank.Branch_Name,
                    description: bank.Branch_Code + ' ' + bank.Branch_Name
                };
            }
            return acc;
        }, {} as IDNameDescriptionDictionary);

        // Update the ChecksBranches state
        setChecksBranches(prevBranches => {
            const newBranches = [...prevBranches];

            for (var i = index; i < newBranches.length; i++) {
                newBranches[i] = branchDictionary;
            }
            console.log('newBranches', newBranches)
            newBranches[0][0] = { id: 0, name: 'בחר', description: 'בחר' };
            // newBranches.splice(0, 0,{ '0': { id: 0, name: 'בחר', description: 'בחר' } });

            //newBranches[index] = branchDictionary;
            return newBranches;
        });
        console.log('ChecksBranches', ChecksBranches)



    }

    const branchNumberCheckChanged = async (name: string, value: any) => {

        const index = parseInt(name);
        console.log('branchNumberCheckChanged', name, value)

        // Update the payment checks state
        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];
            console.log('newChecks 1', newChecks)
            for (var i = index; i < newChecks.length; i++) {
                newChecks[i].paymentCheck.branchNumber = value;
            }
            console.log('newChecks 2', newChecks)

            return newChecks;
        });

    }

    const branchNumberChanged = async (name: string, value: any) => {

        setBranchNumber(value);

    }

    const accountNumberCheckChanged = (value: number, index: number) => {

        // Update the payment checks state
        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];

            for (var i = index; i < newChecks.length; i++) {
                newChecks[i].paymentCheck.accountNumber = value;
            }
            return newChecks;
        });

    }

    const checkNumberCheckChanged = (value: number, index: number) => {

        // Update the payment checks state
        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];
            //newChecks[index].checkNumber = value;
            for (var i = index; i < newChecks.length; i++) {
                newChecks[i].paymentCheck.checkNumber = (value++) + "";
            }
            return newChecks;
        });

    }

    const dueDateCheckChanged = (e: Date, i: string) => {

        const index = parseInt(i);
        const initialDate = new Date(e); // Clone the initial date

        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];

            for (let j = index; j < newChecks.length; j++) {
                newChecks[j].paymentCheck.dueDate = new Date(initialDate); // Set a new Date object
                initialDate.setMonth(initialDate.getMonth() + 1); // Update initialDate

            }

            return newChecks;
        });
    }

    const amountNumberCheckChanged = (value: number, index: number) => {

        // Update the payment checks state
        setPaymentChecks(prevChecks => {
            const newChecks = [...prevChecks];

            for (var i = index; i < newChecks.length; i++) {
                newChecks[i].paymentCheck.amount = value;
            }
            return newChecks;
        });

    }

    const savePayment = async () => {
// 
        if (await validations()) {
            props.setSaveLoading(true);
            var payment = new PaymentModel();
            if(paymentMethodType == 3 || (paymentMethodType == 0 &&  amount && amount > 0)){
                payment.paymentStatus = 0;// paymentStatus;
                setPaymentStatus(0);
            }
            else{
                payment.paymentStatus = 1;
                setPaymentStatus(1);
            }
            

            if (payment.paymentStatus == 0 && !askedPay) {
                setShowAskedPayPopup(true);

                setAskedPay(true);

               
                return;
            }



            payment.id = id;
            payment.title = title;
            payment.amount = amount;
            payment.paymentMethodType = paymentMethodType;
            payment.paymentsNumber = paymentsNumber;




            payment.bankNumber = bankNumber;
            payment.branchNumber = branchNumber;
            payment.accountNumber = accountNumber;
            payment.bankTransferDate = bankTransferDate;
            payment.paymentChecks = paymentChecks.map(
                (checkWithErrors) => checkWithErrors.paymentCheck
            );;
            // 
            payment.iCerditUrl = iCerditUrl;
            payment.ccChargeCreditId = cCChargeCreditId;
            var res = await new SubscribersModel().paymentUpdatePayment(payment);
            if (res.code == "200") { 
                console.log('savePayment', payment)
                props.ClosePopup();
                if(payment.paymentStatus == 1){
                    props.setPopupShow(true);
                    props.setMessege("תשלום נקלט ואושר חשבונית קיימת בכרטיס הלקוח");
                    props.setSaveLoading(false);

                }else if(payment.paymentStatus == 0){
                    props.setPopupShow(true);
                    props.setMessege("לא בוצע תשלום");
                    props.setSaveLoading(false);

                }
             }
            else {
                setPaymentErr(res.label);
                props.setSaveLoading(false);

            }
        }
    }

    const isValidDate = (input: Date | undefined): boolean => {
        if (!input) return false; // Check if input is undefined
        const minValidDate = new Date("0001-01-02"); // Date just after "01/01/0001"

        // Check if the date is valid and not "01/01/0001"
        return !isNaN(input.getTime()) && input >= minValidDate;
    }


    const validations = async () => {
        var isValid = true;
        if (paymentMethodType == 2) { //bank transfer
            if (!bankTransferDate || !isValidDate(bankTransferDate)) {

                setBankTransferDateErrMsg("* תאריך שגוי");

                isValid = false;
            }
            else {
                setBankTransferDateErrMsg("");
            }

            if (!bankNumber || bankNumber == 0) {

                setBankNumberErrMsg("* חובה");

                isValid = false;
            }
            else {
                setBankNumberErrMsg("");
            }
            if (!branchNumber || branchNumber == 0) {

                setBranchNumberErrMsg("* חובה");

                isValid = false;
            }
            else {
                setBranchNumberErrMsg("");
            }
            if (!accountNumber || accountNumber == 0) {

                setAccountNumberErrMsg("* חובה");

                isValid = false;
            }
            else {
                setAccountNumberErrMsg("");

            }


        }
        if (paymentMethodType == 1) {//check
            var checkSum = 0;
            for (let i = 0; i < paymentChecks.length; i++) {
                const check = paymentChecks[i];


                if (!check.paymentCheck.amount || check.paymentCheck.amount == 0) {

                    check.errors.amountErrorMsg = "* סכום שגוי";

                    isValid = false;
                }
                else {
                    check.errors.amountErrorMsg = "";
                    checkSum += parseInt(check.paymentCheck.amount + "");
                }

                if (!check.paymentCheck.bankNumber || check.paymentCheck.bankNumber == 0) {

                    check.errors.bankNumberErrorMsg = "* חובה";

                    isValid = false;
                }
                else {
                    check.errors.bankNumberErrorMsg = "";

                }
                if (!check.paymentCheck.branchNumber || check.paymentCheck.branchNumber == 0) {

                    check.errors.branchNumberErrorMsg = "* חובה";


                    isValid = false;
                }
                else {
                    check.errors.branchNumberErrorMsg = "";
                }
                if (!check.paymentCheck.accountNumber || check.paymentCheck.accountNumber == 0) {
                    check.errors.accountNumberErrorMsg = "* חובה";

                    isValid = false;
                }
                else {
                    check.errors.accountNumberErrorMsg = "";

                }
                if (!check.paymentCheck.dueDate || !isValidDate(check.paymentCheck.dueDate)) {
                    check.errors.dueDateErrorMsg = "* תאריך שגוי";

                    isValid = false;
                }
                else {
                    check.errors.dueDateErrorMsg = "";
                }
            }
            if (checkSum != amount) {
                setPaymentChecksErrMsg("סכום המחאות שונה מסכום כולל");
                isValid = false;
            }

        }

        if (isValid && paymentMethodType != 3) {
            const newStatus = 1;
            await setPaymentStatus(newStatus);


        }

        return isValid;
    }

    const loadNewPayment = async () => {
        var payment = new PaymentModel();
        // 
        payment.riderId = riderId;
        payment.title = title;
        payment.amount = amount;

        var res = await new SubscribersModel().paymentUpdatePayment(payment);
        console.log('loadNewPayment res', res)
        props.Reload(res.val);
    }

    const paymentNumberChanged2 = (name: string, value: any) => {
        // 

        paymentNumberChanged(value);
    }


    const setNewAmount =  (value: number) => {

        // setTimeout(() => {
        //     let old = oldAmount ? oldAmount : 0;
        //     props.setPopupShow(true);
        //     props.setMessege(`שונה סכום לתשלום מ${old} ל${value}`);
        // }, 1000);
        
        // setAmount(value);
        const payment = new PaymentModel();
        payment.id = id;
        payment.amount = value;
        payment.title = title;
        payment.riderId = riderId;
        payment.iCerditUrl = iCerditUrl;
        payment.ccChargeCreditId = cCChargeCreditId;
        fetchData(payment);

        let old = oldAmount ? oldAmount : 0;
        props.setPopupShow(true);
        props.setMessege(`שונה סכום לתשלום מ${old} ל${value}`);
        // var res = await new SubscribersModel().paymentUpdateAmount(payment);

    } 

    const changeAmount = (value: number) => {
        setAmount(value);
    }

    const fetchData = async (payment: PaymentModel) =>{
        console.log('payment', payment)
        var res = await new SubscribersModel().paymentUpdateAmount(payment);
        console.log('loadNewPayment res', res)
        // props.Reload(res.id);

        // setId(res.id);
        // setTitle(res.title);
        // setPaymentMethodType(res.paymentMethodType);
        // setPaymentsNumber(res.paymentsNumber);
        // setPaymentStatus(res.paymentStatus);
        // setBankNumber(res.bankNumber);
        // setBranchNumber(res.branchNumber);
        // setAccountNumber(res.accountNumber);
        // setBankTransferDate(res.bankTransferDate);
        // setPaymentChecks(res.paymentChecks.map((x: PaymentCheckModel) => new PaymentCheckWithErrors(x)));
        setICerditUrl(res.iCerditUrl);
        // setCCChargeCreditId(res.ccChargeCreditId);

    }

    const isAllowedToChangeAmount = () => {
        const userLogged = localStorage.getItem('loggedUser');
        if(userLogged){
            const user = JSON.parse(userLogged);
            if(user.role == 0 || user.role == 8){
                return true;
            }
        }
        return false;
    }

    return (
        <div >

            {showAskedPayPopup ? <div className="popup-wrapper">
                <section className="popup-window new-subscriber rtl">
                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title">
                                לא בוצע תשלום האם להמשיך בשמירה?
                            </div>
                        </div>
                        <div className="popup-body">

                        </div>
                        <div className="popup-footer">

                            <button className="button white blue-border" onClick={(e: any) => setShowAskedPayPopup(false)}>
                                לא
                            </button>

                            <button className="button white blue-border" onClick={(e: any) => { setShowAskedPayPopup(false); setContinueWothoutPaying(true);
                             }}>
                                כן
                            </button>
                        </div>
                    </div>
                </section>
            </div> : ""}


            <div className="tab-content-title-payment">
                לתשלום
            </div>
            <div
  className="tab-content-title-payment"
  dangerouslySetInnerHTML={{ __html: comment ?comment: "" }}
/>
            {newPayment ? <div className="parameter-row payment-details new" style={{alignItems: 'center'}}>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            מהות התשלום

                        </div>
                        <div className="value">
                            <textarea value={title} onChange={(e: any) => setTitle(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            סכום לתשלום
                        </div>
                        <div className="value">
                        {<input type="number" value={amount} onChange={(e: any) => setAmount(e.target.value)} disabled={!isAllowedToChangeAmount()}/>}

                        </div>
                        <div className='error-message2'>{paymentChecksErrMsg}</div>

                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field next-btn">
                        <button type="button" className="button-next" onClick={loadNewPayment} disabled={title === "" || amount === undefined || amount === 0}>הבא</button>
                    </div>
                </div>


            </div> : <div>
                <div className="parameter-row payment-details cc">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מהות התשלום

                            </div>
                            <div className="value">
                                <textarea value={title} onChange={(e: any) => setTitle(e.target.value)} disabled={true}  />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item" style={{width: 200}}>
                        <div className="field">
                            <div className="title">
                                סכום לתשלום
                            </div>
                            <div className="value">
                                {(amount && amount > 0) || props.isAdmin()  ? <input type="number" value={amount} onBlur={(e: any) => setNewAmount(e.target.value)} onChange={(e: any) => changeAmount(e.target.value)} disabled={!isAllowedToChangeAmount()} /> : amount}
                                
                            </div>
                            <div className='error-message2'>{paymentChecksErrMsg}</div>

                        </div>
                    </div>
                    <div className="parameter-item" style={{width: 300}}>
                        <div className="field">
                            <div className="title">
                                אופן התשלום
                            </div>
                            <div className="value">
                                <IDNameDescriptionItemSelect OnChange={paymentMethodTypeChanged} Id={"paymentMethodType"} 
                                Options={PaymentMethodTypes} 
                                Value={paymentMethodType} />
                            </div>
                        </div>
                    </div>
                    <div className={paymentMethodType == 1 ? "parameter-item" : "hide"} style={{width: 300}}>
                        <div className="field">
                            <div className="title">
                                מס' תשלומים
                            </div>
                            <div className="value">
                                {/* <input type="number" max={12} value={paymentsNumber} onChange={(e: any) => paymentNumberChanged(e.target.value)} />

                                <div className="icon small-icon select-arrow pointer"></div> */}

                                    <select
                                    value={paymentsNumber}
                                    onChange={(e: any) => paymentNumberChanged(e.currentTarget.selectedOptions[0].value)}
                                    onSelect={(e: any) => paymentNumberChanged(e.currentTarget.selectedOptions[0].value)}
                                    // You can add a custom className here if needed
                                    // className="payments-select"
                                    >
                                    {/* First placeholder option */}
                                    <option value="">בחר מספר</option>

                                    {/* Options 1..12 */}
                                    {paymentOptions.map((optionValue) => (
                                        <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                        </option>
                                    ))}
                                    </select>

                                    
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item" style={{width: 200}}>
                        <div className="field">
                            <div className="title">
                                סטטוס
                            </div>
                            <div className="value" >
                                <IDNameDescriptionItemSelect OnChange={paymentStatusChanged} Id={"paymentStatus"} Options={paymentStatuses} Value={paymentStatus} Disabled={true} />
                                {/* <div className="icon small-icon select-arrow pointer"></div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={paymentMethodType == 0 ? "payment-bank-transfer" : "hide"}>
                {amount && amount > 0 ? <iframe
                    src={iCerditUrl}
                    width="100%"
                    height={1000}
                    title={title}
                    style={{ border: 'none' }}
                /> :

                    <div className="parameter-row payment-details">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    כרטיס להחזר
                                </div>
                                <div className={paymentMethodType == 0 && paymentStatus != 1 ? "value" : "hide"} >

                                    <IDNameDescriptionItemSelect OnChange={cCChargeCreditChanged} Id={"cCChargeCreditId"} Options={ccChargeCredit} Value={cCChargeCreditId} />

                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מספר תשלומים

                                </div>
                                <div className={paymentMethodType == 0 && paymentStatus != 1 ? "value" : "hide"}>
                                    {amount && amount > 0 ? "" :
                                        <DynamicSelect
                                            OnChange={paymentNumberChanged2}
                                            ClassName=""
                                            Value={
                                                paymentsNumber
                                            }
                                            Options={
                                                Array.from({ length: maxPayments || 0 }, (_, i) => ({
                                                    Text: (i + 1).toString(),
                                                    Value: (i + 1).toString(),
                                                }))
                                            }
                                            Id={"paymentsNumber"} />
                                    }
                                </div>
                            </div>
                        </div>





                    </div>

                }

</div>





                <div className='error-message2'>{paymentErr}</div>



                <div className={paymentMethodType == 1 ? "payment-bank-transfer" : "hide"}>
                    <div className=" payment-check">
                        <div className="parameter-row check-data-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        בנק
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        סניף
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מס חשבון
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מס' שיק
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        ת. פרעון
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        סכום
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {paymentChecks.map((item: PaymentCheckWithErrors, index: number) => (
                        <div key={index}>
                            <div className=" payment-check">
                                <div className="parameter-row check-data-row">
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                <IDNameDescriptionItemSelect OnChange={bankNumberCheckChanged} Id={index + ""} Options={Banks} Value={item.paymentCheck.bankNumber} />

                                            </div>
                                            <div className='error-message2'>{item.errors.bankNumberErrorMsg}</div>

                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                <IDNameDescriptionItemSelect OnChange={branchNumberCheckChanged} Id={index + ""} Options={ChecksBranches[index] ? ChecksBranches[index] : new IDNameDescriptionDictionary()} Value={item.paymentCheck.branchNumber} />

                                            </div>
                                            <div className='error-message2'>{item.errors.branchNumberErrorMsg}</div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                <input type="number" value={item.paymentCheck.accountNumber} onChange={(e: any) => accountNumberCheckChanged(e.target.value, index)} />
                                            </div>
                                            <div className='error-message2'>{item.errors.accountNumberErrorMsg}</div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                <input type="number" value={item.paymentCheck.checkNumber} onChange={(e: any) => checkNumberCheckChanged(e.target.value, index)} />
                                            </div>
                                            <div className='error-message2'>{item.errors.checkNumberErrorMsg}</div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                {/* <DatePicker
                                                    selected={item.paymentCheck.dueDate}
                                                    onSelect={(e: any) => dueDateCheckChanged(e, index + "")}
                                                    onChange={(e: any) => dueDateCheckChanged(e, index + "")}
                                                    dateFormat='dd/MM/yyyy'
                                                /> */}
                                                <CompDatePicker
                                                    value={item.paymentCheck.dueDate}
                                                    // onSelect={(e: any) => dueDateCheckChanged(e, index + "")}
                                                    onChange={(e: any) => dueDateCheckChanged(e, index + "")}
                                                />
                                            </div>
                                            <div className='error-message2'>{item.errors.dueDateErrorMsg}</div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">

                                            <div className="value">
                                                <input type="number" value={item.paymentCheck.amount} onChange={(e: any) => amountNumberCheckChanged(e.target.value, index)} />
                                            </div>
                                            <div className='error-message2'>{item.errors.amountErrorMsg}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    ))}



                </div>
                <div className={paymentMethodType == 2 ? " payment-bank-transfer" : "hide"}>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    בנק
                                </div>
                                <div className="value">
                                    <IDNameDescriptionItemSelect OnChange={bankNumberChanged} Id={"bankNumber"} Options={Banks} Value={bankNumber} />

                                </div>
                                <div className='error-message2'>{bankNumberErrMsg}</div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    סניף
                                </div>
                                <div className="value">
                                    <IDNameDescriptionItemSelect OnChange={branchNumberChanged} Id={"branchNumber"} Options={Branches} Value={branchNumber} />


                                </div>
                                <div className='error-message2'>{branchNumberErrMsg}</div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מס חשבון
                                </div>
                                <div className="value">
                                    <input type="number" value={accountNumber} onChange={(e: any) => setAccountNumber(e.target.value)} />
                                </div>
                                <div className='error-message2'>{accountNumberErrMsg}</div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך העברה
                                </div>
                                <div className="value">
                                    {/* <DatePicker
                                        selected={bankTransferDate}
                                        onSelect={(e: Date) => setBankTransferDate(e)}
                                        onChange={(e: Date) => setBankTransferDate(e)}
                                        dateFormat='dd/MM/yyyy'

                                    /> */}
                                    <CompDatePicker
                                        value={bankTransferDate}
                                        onChange={(e: Date) => setBankTransferDate(e)}
                                    />
                                </div>
                                <div className='error-message2'>{bankTransferDateErrMsg}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}



        </div>

    );
};


export default Payment;
